import api from './api';

export const getWeeks = async () => {
  const { data } = await api.get('/schedule/weeks');
  return data;
};

export const getGrid = async (weekId) => {
  const { data } = await api.get(`/schedule/grid/${weekId}`);
  return data;
};

export const createEntry = async (entryData) => {
  const { data } = await api.post('/schedule/entries', entryData);
  return data;
};

export const updateEntry = async (id, entryData) => {
  const { data } = await api.put(`/schedule/entries/${id}`, entryData);
  return data;
};

export const deleteEntry = async (id) => {
  await api.delete(`/schedule/entries/${id}`);
};

export const moveEntry = async (id, moveData) => {
  const { data } = await api.put(`/schedule/entries/${id}/move`, moveData);
  return data;
};

export const exportGrid = async (weekId) => {
  const { data } = await api.get(`/schedule/export/${weekId}`);
  return data;
};

export const createWeek = async (weekData) => {
  const { data } = await api.post('/schedule/weeks', weekData);
  return data;
};

// Shows
export const getShows = async () => {
  const { data } = await api.get('/shows');
  return data;
};

export const getAllShows = async () => {
  const { data } = await api.get('/shows/all');
  return data;
};

export const getShow = async (id) => {
  const { data } = await api.get(`/shows/${id}`);
  return data;
};

export const createShow = async (showData) => {
  const { data } = await api.post('/shows', showData);
  return data;
};

export const updateShow = async (id, showData) => {
  const { data } = await api.put(`/shows/${id}`, showData);
  return data;
};

export const deleteShow = async (id) => {
  await api.delete(`/shows/${id}`);
};

// Episodes
export const getEpisodes = async (showId) => {
  const { data } = await api.get(`/shows/${showId}/episodes`);
  return data;
};

export const getLatestEpisode = async (showId) => {
  const { data } = await api.get(`/shows/${showId}/episodes/latest`);
  return data;
};

export const getEpisode = async (id) => {
  const { data } = await api.get(`/episodes/${id}`);
  return data;
};

export const createEpisode = async (showId, episodeData) => {
  const { data } = await api.post(`/shows/${showId}/episodes`, episodeData);
  return data;
};

export const updateEpisode = async (id, episodeData) => {
  const { data } = await api.put(`/episodes/${id}`, episodeData);
  return data;
};

export const deleteEpisode = async (id) => {
  await api.delete(`/episodes/${id}`);
};

export const getEpisodeXml = async (id) => {
  const response = await api.get(`/episodes/${id}/xml`, {
    responseType: 'blob',
    transformResponse: [(data) => data],
  });
  return response.data;
};
